module.exports = __webpack_public_path__ + "b1053d1eda9fa210096d62328e4daf1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo_White.png
// module id = VXZd
// module chunks = 1